import { useSuspenseQuery } from "@apollo/client/react";

import { GetOrganizationsDocument, type GetOrganizationsQuery } from "~/features/admin/organizations/gqls";

/** Read-only list of organizations. Organizations are an admin-level resource, so the query carries no tenantId. */
export function useOrganizationList() {
  return useSuspenseQuery<GetOrganizationsQuery>(GetOrganizationsDocument);
}
